import React from 'react'
import './Header.css'
import { Link } from 'react-router-dom'

export default function Header() {
  return (
    <div className='header'>
    <div class="header-hero" >
          <div class="hero-title">
              <h3>Hello, I'm Nerias Andrade</h3>
              <h1>A Junior Web Developer<br></br> Welcome to my portfolio</h1>
          </div>
    </div>
    <div class="nav">
              <div class="nav-pills">
                  <ul>
                  <li><Link style={{textDecoration: 'none', color: 'inherit'}} to='/'>Home</Link></li>
                  <li><Link style={{textDecoration: 'none', color: 'inherit'}}to='/aboutme'>AboutMe</Link></li>
                  <li><Link style={{textDecoration: 'none', color: 'inherit'}}to='/contactme'>Contact Me</Link></li>
                  </ul>
              </div>
    </div>
    </div>
  )
}
